import axios from 'axios';
import { FETCH_GTV_REQUEST, FETCH_GTV_DATA, FETCH_GTV_ERROR, RESET_GTV_DATA } from './gtvTypes';
import BASE_URL from '../config';

const timeout = 120000;

function _addIds(rows) {
  return Array.isArray(rows) ? rows.map((item, idx) => ({ id: idx, ...item })) : [];
}

export const fetchGTVData = (startDate, endDate, selectedCampaigns) => (dispatch, getState) => {
  dispatch({ type: FETCH_GTV_REQUEST });

  const advertiserId = localStorage.getItem('advertiserId');
  const sfId = localStorage.getItem('sfId');
  const userEmail = getState().userReducer.userEmail;
  const campaignGuids = Array.isArray(selectedCampaigns) ? selectedCampaigns : [];

  return axios({
    method: 'post',
    url: `${BASE_URL}/getGTVData`,
    headers: { 'Content-Type': 'application/json' },
    data: {
      advertiser_id: advertiserId,
      sfId,
      startDate,
      endDate,
      userEmail,
      campaign_guids: campaignGuids
    },
    timeout
  })
    .then((response) => {
      const d = response.data || {};
      return dispatch({
        type: FETCH_GTV_DATA,
        payload: {
          overall: _addIds(d.overall),
          creative: _addIds(d.creative)
        }
      });
    })
    .catch((error) => {
      const msg = error.response?.data?.message || 'Unable to fetch data. Please try again';
      return dispatch({ type: FETCH_GTV_ERROR, payload: msg });
    });
};

export const resetGTVData = () => ({ type: RESET_GTV_DATA });
